module.exports = __webpack_public_path__ + "img/role2.d28685a2.png";